import ListDepthUtils from '../ListDepthUtils';
import { type EventHandler } from '../../../types/aha-editor';

const onTab: EventHandler<KeyboardEvent> = (event, ahaEditor): boolean => {
  event.preventDefault();

  const { editor } = ahaEditor;
  if (event.shiftKey) {
    ListDepthUtils.decreaseDepth(editor);
  } else {
    ListDepthUtils.increaseDepth(editor);
  }

  return true;
};

export default onTab;
